// ** React Imports
import { useContext } from "react";

// ** Redux
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "store/modules/main-pages/posts/get-posts.action";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import LocationAutocomplete from "components/layout/LocationAutocomplete";

// ** Hooks

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";
import AuthContext from "contexts/authContext";
// #####################################################

export const PostsLocationFilter = () => {
	const { t } = useTranslation(["common"]);

	const { isPhone } = useContext(deviceTypeContext);
	const isAuth = useContext(AuthContext);

	const dispatch = useDispatch();

	const locationFromStore = useSelector(
		(state) => state.sharedFilters.location
	);

	const customWidth =
		locationFromStore.cityId === "any" || !locationFromStore.cityId
			? 407
			: 301;

	const handleLocationSelect = (locationData) => {
		dispatch(
			getPosts({
				filters: {
					location: {
						country: locationData.country,
						countryName: locationData.countryName,
						regionId: locationData.regionId,
						regionName: locationData.regionName,
						cityId: locationData.cityId,
						cityName: locationData.cityName,
						distance: locationData.distance,
						showError: locationData.showError,
					},
				},
				isAuth,
			})
		);
	};

	// #####################################################

	return (
		<LocationAutocomplete
			location={locationFromStore}
			onAccept={handleLocationSelect}
			label={t("filtersAndSelectors:locationLabel")}
			withDistance
			withLabel
			minWidth={isPhone ? 200 : customWidth || 307}
			withGeolocation
			noPad
			noOther
			extend
		/>
	);
};

// #####################################################

export default PostsLocationFilter;

// #####################################################
